import React, { createContext, useContext, useState } from 'react';
import { CreativityType } from '../types/banner';

interface FormContextType {
  creativityType: CreativityType | null;
  setCreativityType: (type: CreativityType) => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [creativityType, setCreativityType] = useState<CreativityType | null>(null);

  const value: FormContextType = {
    creativityType,
    setCreativityType
  };

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export const useFormContext = (): FormContextType => {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};
